import { call, put } from 'redux-saga/effects';
import LeaveActions from '../redux/LeaveRedux';
import { api } from './api';


export function* leave(action: any): Generator<any, void, any> {
  const { leave: leaveData } = action;

  const response = yield call(api.leave, leaveData);

  // success?
  if (response.ok) {
    yield put(LeaveActions.leaveSuccess(response?.data?.data));
  } else {
    yield put(LeaveActions.leaveFailure());
  }
}